import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import '../src/views/loader.css'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const ProviderLogin = React.lazy(() => import('./views/pages/providerlogin/Login'))
const Logout = React.lazy(() => import('./views/pages/logout/Logout'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const History = React.lazy(() => import('./views/custom/History-update/History'))
const Terms = React.lazy(() => import('./views/custom/Terms/Terms'))
const About = React.lazy(() => import('./views/custom/About/About'))
const Policy = React.lazy(() => import('./views/custom/Policy/Policy'))
const ForgetPassword= React.lazy(()=>import('./views/pages/provider_forget_password/Forgetpassword'))
class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/providerlogin" name="ProviderLogin Page" element={<ProviderLogin />} />
            <Route exact path="/forget-password" name="Forget Password Page" element={<ForgetPassword />} />
            <Route exact path="/logout" name="Logout Page" element={<Logout />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route exact path="/update-history" name="Privacy-policy" element={<History />} />
            <Route exact path="/about" name="about" element={<About />} />
            <Route exact path="/terms-conditions" name="Privacy-policy" element={<Terms />} />
            <Route exact path="/privacy-policy" name="privacy-policy" element={<Policy />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
